import { useEffect } from "react";
import { atom, useAtom, useSetAtom } from "jotai";

export type Theme = "blight" | "dark" | "sepia";

const themeAtom = atom<Theme>("blight");

export function useThemeInitialization() {
  const [theme, setTheme] = useAtom(themeAtom);
  useEffect(() => {
    setTheme((localStorage.getItem("ui-theme") as Theme) || "blight");
  }, []);
  useEffect(() => {
    document.body.dataset.uitheme = theme;
    localStorage.setItem("ui-theme", theme);
  }, [theme]);
}

export function useToggleTheme() {
  const setValue = useSetAtom(themeAtom);
  const next: Record<Theme, Theme> = {
    blight: "sepia",
    sepia: "dark",
    dark: "blight",
  };
  return () => {
    setValue((cur) => next[cur]);
  };
}
